import { changeEmail } from 'api/membership';
import { ChangeEmailBody } from 'interfaces/membership';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from 'modules/Notifications';
import { useMutationWithResultNotification } from '../useMutationWithResultNotification';

function useEditEmail(userId, successFb?: () => void) {
  return useMutationWithResultNotification({
    asyncApiFunction: async ({ new_email, password }: ChangeEmailBody) => {
      await changeEmail(userId, new_email, password);
    },
    resetOnResult: true,
    onSuccess: () => {
      displaySuccessNotification('MyProfile.edit.emailChangeSuccess');
      successFb && successFb();
    },
    onErrorArray: (errorArray) => {
      displayErrorArrayNotifications(
        errorArray,
        'MyProfile.edit.emailChangeError'
      );
    },
  });
}

export default useEditEmail;
